<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Während der Bundesgartenschau in Koblenz besuchten mehr als 3 Millionen Besucher den Bau auf dem Festungsplateau in Ehrenbreitstein. Der mehrfach ausgezeichnete Pavillon befand sich im Ausstellungsbereich „Vielfalt des Lebens — Lernen von der Natur“ auf der Bundesgartenschau Koblenz 2011. Das Thema des Gartens lautete „Vielfalt als Vorbild — Bionik“.</p>
            <br>
            <p>Auf dem Boden der Struktur wurde das Oszillogramm der Ortungsrufe der Fledermaus mit LED-Leuchtstreifen visualisiert; über Lautsprecher wurden zudem die hörbar gemachten Ortungsrufe der Fledermäuse in Interaktion mit den Besuchern durch Bewegungsmelder aktiviert und ausgesendet. Über Bewegungsmelder steuerten die Besucher aktiv LED-Leuchtstreifen wie auch die Aussendung der akustischen Signale aus der sich der Grundriss, der Aufriss und die komplette Konstruktion des Baus ableiten. </p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 items-center w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="10/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="mt-5">
            <span class="font-semibold">Entwurf und Realisierung</span><br />
            <p class="leading-tight">
                Prof. Dr.-Ing. Manfred Feyerabend<br />
                Prof. Dr.-Ing. Markus Holzbach<br />
                Jennifer B&ouml;hm B.A., Simon G&ouml;rgen, Raunahi Hamo, Andreas Meister, Constantin M&uuml;ller B.A., Kristina M&uuml;lligann B.A., Natalie M&uuml;nch B.A., Alexander Schumann, Chao Yang.<br />
                <br />
                <span class="font-semibold">Planung Licht und Ton</span><br />
                Prof. Dr. Jens Bongartz<br />
                Dipl.-Ing. Alexander Jenal M. Sc.<br />
                Thomas Giese<br />
                Martin Krings<br />
                <br />
                <span class="font-semibold">Projekt Hochschule Koblenz</span><br />
                Bauherr.<br />
                Fachhochschule Koblenz, Konrad-Zuse-Str. 1, 56075 Koblenz<br />
                Datum der Fertigstellung<br />
                M&auml;rz 2011<br />
            </p>
        </div>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/Innen22.jpg' ),
                require( '@/assets/img/pc/CIMG0198.jpg' ),
                require( '@/assets/img/pc/CIMG0278.jpg' ),
                require( '@/assets/img/pc/Echolot-Pavillon-3.jpg' ),
                require( '@/assets/img/pc/innen02.jpg' ),
                require( '@/assets/img/pc/3-2.jpg' ),
                // require( '@/assets/img/pc/Was-ist-das-a24446486.jpg' ),
                require( '@/assets/img/pc/020.jpg' ),
                require( '@/assets/img/pc/10-06-04_RFEM-Spannungen_ohne_Skala.jpg' ),
                require( '@/assets/img/pc/080.jpg' ),
                require( '@/assets/img/pc/090.jpg' ),
                require( '@/assets/img/pc/CIMG0030.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>